import { render, staticRenderFns } from "./BooleanCell.vue?vue&type=template&id=0f7508a3&scoped=true&"
import script from "./BooleanCell.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BooleanCell.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BooleanCell.vue?vue&type=style&index=0&id=0f7508a3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7508a3",
  null
  
)

export default component.exports